import React, { useEffect, useState } from 'react';

const EnvironmentIndicator: React.FC = () => {
    const [environment, setEnvironment] = useState<string>('unknown');

    useEffect(() => {
        // Get project ID from environment variables
        const envProjectId = import.meta.env.VITE_FIREBASE_PROJECT_ID;

        // // Get project ID from Firebase app
        // let firebaseProjectId = 'unknown';
        // try {
        //     const app = getApp();
        //     firebaseProjectId = app.options.projectId || 'unknown';
        // } catch (error) {
        //     console.error('Error getting Firebase app:', error);
        // }

        // console.log('Environment Debug:');
        // console.log('- VITE_FIREBASE_PROJECT_ID:', envProjectId);
        // console.log('- Firebase app projectId:', firebaseProjectId);

        // Set environment based on environment variable
        if (envProjectId === 'fg2p-test') {
            setEnvironment('test');
        } else if (envProjectId === 'fg2p-prod') {
            setEnvironment('production');
        } else {
            setEnvironment('unknown');
        }
    }, []);

    // Only show the indicator in test environment
    if (environment !== 'test') {
        return null;
    }

    return (
        <div style={{
            position: 'fixed',
            top: 5,
            left: '50%',
            transform: 'translateX(-50%)',
            backgroundColor: 'yellow',
            color: 'black',
            padding: '5px 20px',
            zIndex: 9999,
            fontWeight: 'bold',
            fontSize: '14px',
            borderRadius: '5px',
            textAlign: 'center',
        }}>
            <span style={{ whiteSpace: 'nowrap' }}>TEST ENVIRONMENT</span>
        </div>
    );
};

export default EnvironmentIndicator; 